import { useState, useEffect } from 'react';
import { AdminCompany } from '../types';
import { adminCompaniesService } from '../services/admin-companies.service';

export const useAdminCompanies = () => {
  const [companies, setCompanies] = useState<AdminCompany[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadCompanies = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await adminCompaniesService.getAllCompanies();
      setCompanies(data);
    } catch (err: any) {
      setError(err.message || 'Failed to load companies');
    } finally {
      setIsLoading(false);
    }
  };

  const createCompany = async (companyData: Partial<AdminCompany>) => {
    const result = await adminCompaniesService.createCompany(companyData);
    if (result) {
      await loadCompanies();
    }
    return result;
  };

  const updateCompany = async (companyId: number, companyData: Partial<AdminCompany>) => {
    const result = await adminCompaniesService.updateCompany(companyId, companyData);
    if (result) {
      await loadCompanies();
    }
    return result;
  };

  const deleteCompany = async (companyId: number) => {
    const success = await adminCompaniesService.deleteCompany(companyId);
    if (success) {
      await loadCompanies();
    }
    return success;
  };

  useEffect(() => {
    loadCompanies();
  }, []);

  return {
    companies,
    isLoading,
    error,
    loadCompanies,
    createCompany,
    updateCompany,
    deleteCompany,
  };
};

